import MockAdapter from 'axios-mock-adapter';

export function authenticationPublicMocks(mock: MockAdapter): void {
  mock.onPost('/api/login').reply(
    200,
    {
      signIn: true,
      accountId: 562,
      status: 0,
    },
    {
      __kreezeesession__: `{"Session":{"CurrentUser":{"Id":562,"LastName":"Gagnon","FirstName":"Sylvain","NickName":"","Avatar":null,"Picture":"images/teams/31d9f5dc.jpg","Culture":"en","Email":"sylvain@kreezee.com","IsAdminKreezee":true,"StayConnected":false,"Sex":0,"Birthday":null,"Phones":[],"UserAddress":null},"Messages":[],"SecurityToken":"8eef15b7-1f85-9e27-cb6b-4f1adbdf45f5","Expires":"2021-01-07T16:45:26.1354642Z"},"Digest":"/TVsiVMYwUQvcDs/mOzjeNrmKmY5ODr5eKQ55MeSMZM="}`,
    },
  );
  mock.onPost('/api/login/facebook').reply(200, {
    culture: 'fr',
    email: null,
    firstName: 'Doge Such',
    jwt: 'facebookjwt',
    name: 'Facebook Wow',
  });

  mock.onPost('/api/login/google').reply(200, {
    culture: 'fr',
    email: null,
    firstName: 'Doge Such',
    jwt: 'googlejwt',
    name: 'Google Wow',
  });
}

export function authenticationSecureMocks(mock: MockAdapter): void {
  mock.onPost('/api/authentication/signout').reply(200, null, {
    __kreezeesession__: {
      Session: {
        CurrentUser: {
          Id: 562,
          LastName: 'Gagnon',
          FirstName: 'Sylvain',
          NickName: '',
          Avatar: null,
          Picture: 'images/teams/31d9f5dc.jpg',
          Culture: 'en',
          Email: 'sylvain@kreezee.com',
          IsAdminKreezee: true,
          StayConnected: false,
          Sex: 0,
          Birthday: null,
          Phones: [],
          UserAddress: null,
        },
        Messages: [],
        SecurityToken: '8eef15b7-1f85-9e27-cb6b-4f1adbdf45f5',
        Expires: '2021-01-07T16:45:26.1354642Z',
      },
      Digest: '/TVsiVMYwUQvcDs/mOzjeNrmKmY5ODr5eKQ55MeSMZM=',
    },
  });
}
